/** True only for real checked tokens. The string `"false"` must stay unchecked. */
export function isCheckedValue(value: unknown): boolean {
	if (value === true || value === 1) return true;
	if (typeof value !== "string") return false;
	const token = value.trim().toLowerCase();
	return token === "true" || token === "yes" || token === "1";
}
